import { BuildType } from 'src/enums/build/build-type';
import { colors } from 'src/styling/constants';

export type Colors = {
  bodyText: string;
  highlight: string;
  highlightText: string;
  headerNavigationText: string;
  background: string;
  backgroundLight: string;
  border: string;
  headerBorder: string;
  fadedHighlight: string;
  darkHighlight: string;
  secondaryBackground: string;
  grayBackground: string;
  copyrightGray: string;
  secondaryHighlight: string;
  footerText: string;
  footerNavMenuTitle: string;
  alert: string;
  headerBackground: string;
  headerClubName: string;
  goldHighlight: string;
  darkGoldHighlight: string;
  successGreen: string;
  paleRed: string;
  footerBackground: string;
  quadrantTextBorder?: string;
  lightGrayText?: string;
  modalCloseButtonBackgroundColor: string;
  promoBannerColor: string;
  specialOfferTextColor: string;
  promoBannerTitleColor: string;
  promoDescriptionColour: string;
  packageDrawbackColor: string;
  mobileBannerColor: string;
  paymentBlockBackgroundColor: string;
  paymentBlockTitleColor: string;
  timetableCardBackground: string;
  timetableCardText: string;
  popupSecondaryActionBackground?: string;
  popupSecondaryActionBorder?: string;
  subtitledLinkImageSubtitleBackground: string;
  subtitledLinkImageSubtitleText: string;
  packageCardPriceBanner: string;
  focusOutlineColor: string;
  comingSoonHero: string;
  comingSoonHeroBorder: string;
  placeholderText: string;
  clubFinderText: string;
  clubFinderSearch: string;
  clubFinderComingSoonBackground: string;
  clubFinderComingSoonBorder: string;
  clubFinderComingSoonText: string;
  progressBarIncomplete: string;
  progressBarComplete: string;
  /* NWP colors */
  accordionIcon: string;
  introText: string;
  darkGreen: string;
  camelot: string;
  capeCod: string;
  hessianBackground: string;
  vibrant: string;
  brightYellow: string;
  sageBackground: string;
  ash: string;
  davidLloydGray: string;
  brightGrey: string;
  transparentGreenGrey: string;
  grayOlive: string;
  transparentGrayOlive: string;
  disabledText: string;
  error: string;
  errorBoundary: string;
  lightGreen: string;
  pinBorder: string;
  inputFocusOutline: string;
  inputActiveBackground: string;
  lightBackground: string;
  greyBackground: string;
  meridianOrange: string;
  meridianOrangeHover: string;
  meridianBlue: string;
  meridianPaleOrange: string;
  meridianBrightBlue: string;
  meridianFadeBlue: string;
  cream: string;
  iconChatColor: string;
  harbourGold: string;
  harbourSlateGrey: string;
  harbourHoverGrey: string;
  harbourHoverGold: string;
  paleGold: string;
  linkColor: string;
};

export const getColors = (buildType: BuildType): Colors => {
  switch (buildType) {
    case BuildType.HARBOUR:
      return {
        bodyText: colors.capeCod,
        highlight: colors.harbourGold,
        highlightText: colors.harbourGold,
        headerNavigationText: colors.harbourGold,
        background: colors.davidLloydGray,
        backgroundLight: colors.davidLloydGray,
        border: colors.borderGrey,
        fadedHighlight: colors.fadedHarbourGold,
        secondaryBackground: 'white',
        darkHighlight: colors.harbourDarkGold,
        grayBackground: colors.davidLloydGray,
        headerBorder: colors.harbourHeaderBorder,
        copyrightGray: colors.lightGray,
        secondaryHighlight: colors.harbourGold,
        footerText: 'white',
        footerNavMenuTitle: colors.harbourGold,
        headerBackground: colors.capeCod,
        headerClubName: 'white',
        alert: colors.alert,
        goldHighlight: colors.highlightGold,
        darkGoldHighlight: colors.harbourDarkGold,
        successGreen: colors.davidLloydTeal,
        paleRed: colors.paleRed,
        footerBackground: colors.capeCod,
        modalCloseButtonBackgroundColor: colors.fadedHarbourGold,
        promoBannerColor: colors.capeCod,
        specialOfferTextColor: colors.harbourGold,
        promoBannerTitleColor: 'white',
        promoDescriptionColour: colors.capeCod,
        packageDrawbackColor: colors.silver,
        mobileBannerColor: colors.harbourGold,
        paymentBlockBackgroundColor: colors.paleGrey,
        paymentBlockTitleColor: colors.capeCod,
        timetableCardBackground: 'white',
        timetableCardText: colors.capeCod,
        subtitledLinkImageSubtitleBackground: colors.capeCod,
        subtitledLinkImageSubtitleText: 'white',
        packageCardPriceBanner: colors.beigeGrey,
        focusOutlineColor: colors.fadedHarbourGold,
        comingSoonHero: colors.fadedHarbourGold,
        comingSoonHeroBorder: colors.harbourDarkGold,
        clubFinderText: colors.clubFinderTextGrey,
        placeholderText: colors.placeHolderTextGrey,
        clubFinderSearch: colors.clubFinderSearchGrey,
        clubFinderComingSoonBackground: 'white',
        clubFinderComingSoonBorder: colors.fadedHarbourGold,
        clubFinderComingSoonText: colors.harbourGold,
        progressBarIncomplete: colors.capeCod,
        progressBarComplete: colors.harbourDarkGold,
        /* NWP colors */
        accordionIcon: colors.copyrightGray,
        introText: colors.introText,
        darkGreen: colors.darkGreen,
        camelot: colors.camelot,
        capeCod: colors.capeCod,
        hessianBackground: colors.hessianBackground,
        vibrant: colors.vibrant,
        brightYellow: colors.brightYellow,
        sageBackground: colors.sageBackground,
        ash: colors.ash,
        davidLloydGray: colors.davidLloydGray,
        brightGrey: colors.brightGrey,
        transparentGreenGrey: colors.transparentGreenGrey,
        grayOlive: colors.grayOlive,
        transparentGrayOlive: colors.transparentGrayOlive,
        disabledText: colors.disabledText,
        error: colors.error,
        errorBoundary: colors.errorBoundary,
        lightGreen: colors.lightGreen,
        pinBorder: colors.pinBorder,
        inputFocusOutline: colors.inputFocusOutline,
        inputActiveBackground: colors.inputActiveBackground,
        lightBackground: colors.cream,
        greyBackground: colors.hessianBackground,
        meridianOrange: colors.meridianOrange,
        meridianPaleOrange: colors.meridianPaleOrange,
        meridianOrangeHover: colors.meridianOrangeHover,
        meridianBlue: colors.meridianBlue,
        meridianBrightBlue: colors.meridianBrightBlue,
        meridianFadeBlue: colors.meridianFadeBlue,
        cream: colors.cream,
        iconChatColor: colors.iconChatColor,
        harbourGold: colors.harbourGold,
        harbourSlateGrey: colors.harbourSlateGrey,
        harbourHoverGrey: colors.harbourHoverGrey,
        harbourHoverGold: colors.harbourHoverGold,
        paleGold: colors.paleGold,
        linkColor: colors.harbourGold,
      };
    case BuildType.MERIDIAN:
      return {
        bodyText: colors.meridianBlue,
        highlight: colors.meridianFieryYellow,
        highlightText: colors.meridianOrange,
        headerNavigationText: colors.meridianBlue,
        background: colors.meridianCoolGray,
        backgroundLight: colors.meridianBackgroundLight,
        border: colors.meridianDivider,
        fadedHighlight: colors.blazeGray,
        secondaryBackground: colors.meridianSecondaryBackground,
        popupSecondaryActionBackground: colors.meridianPopupSecondaryActionBackground,
        popupSecondaryActionBorder: colors.meridianPopupSecondaryActionBorder,
        darkHighlight: colors.meridianOrange,
        grayBackground: colors.meridianCoolGray,
        headerBorder: colors.meridianDivider,
        copyrightGray: colors.blazeGray,
        secondaryHighlight: colors.meridianSecondaryHighlight,
        footerText: 'white',
        footerNavMenuTitle: 'white',
        headerBackground: colors.meridianSecondaryBackground,
        headerClubName: colors.meridianBlue,
        alert: colors.alert,
        goldHighlight: colors.highlightGold,
        darkGoldHighlight: colors.harbourDarkGold,
        successGreen: colors.davidLloydTeal,
        paleRed: colors.paleRed,
        footerBackground: colors.meridianLightGrayFooter,
        meridianDarkGrayFooter: colors.meridianDarkGrayFooter,
        quadrantTextBorder: colors.meridianDarkCoolGray,
        lightGrayText: colors.meridianLightGray,
        modalCloseButtonBackgroundColor: colors.meridianSecondaryHighlight,
        promoBannerColor: colors.meridianHighlightGrey,
        specialOfferTextColor: 'white',
        promoBannerTitleColor: 'white',
        promoDescriptionColour: colors.meridianFieryYellow,
        packageDrawbackColor: colors.blazeGray,
        mobileBannerColor: colors.meridianOrange,
        paymentBlockBackgroundColor: 'white',
        paymentBlockTitleColor: colors.meridianBlue,
        timetableCardBackground: 'white',
        timetableCardText: colors.meridianBlue,
        subtitledLinkImageSubtitleBackground: colors.meridianBlue,
        subtitledLinkImageSubtitleText: 'white',
        packageCardPriceBanner: colors.beigeGrey,
        focusOutlineColor: colors.meridianSecondaryHighlight,
        comingSoonHero: colors.comingSoonPurple,
        comingSoonHeroBorder: colors.comingSoonBorderPurple,
        placeholderText: colors.placeHolderTextGrey,
        clubFinderText: colors.clubFinderTextGrey,
        clubFinderSearch: colors.clubFinderSearchGrey,
        clubFinderComingSoonBackground: 'white',
        clubFinderComingSoonBorder: colors.buttonDisabled,
        clubFinderComingSoonText: colors.davidLloydPurple,
        progressBarIncomplete: colors.meridianBlue,
        progressBarComplete: colors.meridianBlue,
        /* NWP colors */
        accordionIcon: colors.copyrightGray,
        introText: colors.introText,
        darkGreen: colors.darkGreen,
        camelot: colors.camelot,
        capeCod: colors.capeCod,
        hessianBackground: colors.hessianBackground,
        vibrant: colors.vibrant,
        brightYellow: colors.brightYellow,
        sageBackground: colors.sageBackground,
        ash: colors.ash,
        davidLloydGray: colors.davidLloydGray,
        brightGrey: colors.brightGrey,
        transparentGreenGrey: colors.transparentGreenGrey,
        grayOlive: colors.grayOlive,
        transparentGrayOlive: colors.transparentGrayOlive,
        disabledText: colors.disabledText,
        error: colors.error,
        errorBoundary: colors.errorBoundary,
        lightGreen: colors.lightGreen,
        pinBorder: colors.pinBorder,
        inputFocusOutline: colors.inputFocusOutline,
        inputActiveBackground: colors.inputActiveBackground,
        lightBackground: '#FFFFFF',
        greyBackground: colors.lightGray,
        meridianOrange: colors.meridianOrange,
        meridianPaleOrange: colors.meridianPaleOrange,
        meridianOrangeHover: colors.meridianOrangeHover,
        meridianBlue: colors.meridianBlue,
        meridianBrightBlue: colors.meridianBrightBlue,
        meridianFadeBlue: colors.meridianFadeBlue,
        cream: colors.cream,
        iconChatColor: colors.meridianOrange,
        harbourGold: colors.harbourGold,
        harbourSlateGrey: colors.harbourSlateGrey,
        harbourHoverGrey: colors.harbourHoverGrey,
        harbourHoverGold: colors.harbourHoverGold,
        paleGold: colors.paleGold,
        linkColor: colors.meridianBlue,
      } as Colors;
    default:
      return {
        bodyText: colors.capeCod,
        highlight: colors.camelot,
        highlightText: colors.camelot,
        headerNavigationText: colors.camelot,
        background: colors.hessianBackground,
        backgroundLight: colors.hessianBackground,
        border: colors.borderGrey,
        fadedHighlight: colors.buttonDisabled,
        secondaryBackground: colors.cream,
        darkHighlight: colors.davidLloydSecondaryPurple,
        grayBackground: colors.hessianBackground,
        headerBorder: colors.lightGray,
        copyrightGray: colors.copyrightGray,
        secondaryHighlight: colors.davidLloydTeal,
        footerText: colors.capeCod,
        footerNavMenuTitle: colors.capeCod,
        headerBackground: colors.cream,
        headerClubName: colors.capeCod,
        alert: colors.alert,
        goldHighlight: colors.highlightGold,
        darkGoldHighlight: colors.harbourDarkGold,
        successGreen: colors.davidLloydTeal,
        paleRed: colors.paleRed,
        footerBackground: colors.cream,
        modalCloseButtonBackgroundColor: colors.davidLloydTransparentPurple,
        promoBannerColor: colors.highlightGold,
        specialOfferTextColor: 'white',
        promoBannerTitleColor: colors.capeCod,
        promoDescriptionColour: colors.camelot,
        packageDrawbackColor: colors.copyrightGray,
        mobileBannerColor: colors.davidLloydTeal,
        paymentBlockBackgroundColor: colors.paleGrey,
        paymentBlockTitleColor: colors.capeCod,
        timetableCardBackground: colors.cream,
        timetableCardText: colors.capeCod,
        subtitledLinkImageSubtitleBackground: colors.camelot,
        subtitledLinkImageSubtitleText: 'white',
        packageCardPriceBanner: colors.beigeGrey,
        focusOutlineColor: colors.davidLloydTransparentPurple,
        comingSoonHero: colors.comingSoonPurple,
        comingSoonHeroBorder: colors.comingSoonBorderPurple,
        placeholderText: colors.placeHolderTextGrey,
        clubFinderText: colors.clubFinderTextGrey,
        clubFinderSearch: colors.clubFinderSearchGrey,
        clubFinderComingSoonBackground: colors.cream,
        clubFinderComingSoonBorder: colors.buttonDisabled,
        clubFinderComingSoonText: colors.camelot,
        progressBarIncomplete: colors.camelot,
        progressBarComplete: colors.darkGreen,
        /* NWP colors */
        accordionIcon: colors.copyrightGray,
        introText: colors.introText,
        darkGreen: colors.darkGreen,
        camelot: colors.camelot,
        capeCod: colors.capeCod,
        hessianBackground: colors.hessianBackground,
        vibrant: colors.vibrant,
        brightYellow: colors.brightYellow,
        sageBackground: colors.sageBackground,
        ash: colors.ash,
        davidLloydGray: colors.hessianBackground,
        brightGrey: colors.brightGrey,
        transparentGreenGrey: colors.transparentGreenGrey,
        grayOlive: colors.grayOlive,
        transparentGrayOlive: colors.transparentGrayOlive,
        disabledText: colors.disabledText,
        error: colors.error,
        errorBoundary: colors.errorBoundary,
        lightGreen: colors.lightGreen,
        pinBorder: colors.pinBorder,
        inputFocusOutline: colors.inputFocusOutline,
        inputActiveBackground: colors.inputActiveBackground,
        lightBackground: colors.cream,
        greyBackground: colors.hessianBackground,
        meridianOrange: colors.meridianOrange,
        meridianPaleOrange: colors.meridianPaleOrange,
        meridianOrangeHover: colors.meridianOrangeHover,
        meridianBlue: colors.meridianBlue,
        meridianBrightBlue: colors.meridianBrightBlue,
        meridianFadeBlue: colors.meridianFadeBlue,
        cream: colors.cream,
        iconChatColor: colors.iconChatColor,
        harbourGold: colors.harbourGold,
        harbourSlateGrey: colors.harbourSlateGrey,
        harbourHoverGrey: colors.harbourHoverGrey,
        harbourHoverGold: colors.harbourHoverGold,
        paleGold: colors.paleGold,
        linkColor: colors.camelot,
      };
  }
};
